import { userApi } from '@/lib/axios';

export const getUser = () => {
  return userApi.get('/user/get-user-details');
};
